import {
    FETCH_BUSINESSES_REQUEST,
    FETCH_BUSINESSES_SUCCESS,
    FETCH_BUSINESSES_FAILURE,
    UPDATE_BUSINESS_STATUS_REQUEST,
    UPDATE_BUSINESS_STATUS_SUCCESS,
    UPDATE_BUSINESS_STATUS_FAILURE,
  } from "./types";
  
  import { fetchAllBusinesses, updateBusinessStatus } from "../../services/businessService";
  
  // Action Creators
  export const fetchBusinessesRequest = () => ({ type: FETCH_BUSINESSES_REQUEST });
  
  export const fetchBusinessesSuccess = (businessesData) => ({
    type: FETCH_BUSINESSES_SUCCESS,
    payload: businessesData,
  });
  
  export const fetchBusinessesFailure = (error) => ({
    type: FETCH_BUSINESSES_FAILURE,
    payload: error,
  });
  
  // Action Creators for updating business status
  export const updateBusinessStatusRequest = () => ({
    type: UPDATE_BUSINESS_STATUS_REQUEST,
  });
  
  export const updateBusinessStatusSuccess = (updatedBusiness) => ({
    type: UPDATE_BUSINESS_STATUS_SUCCESS,
    payload: updatedBusiness,
  });
  
  export const updateBusinessStatusFailure = (error) => ({
    type: UPDATE_BUSINESS_STATUS_FAILURE,
    payload: error,
  });
  
  // Thunk to fetch all businesses
  export const fetchBusinessesAction = () => async (dispatch) => {
    dispatch(fetchBusinessesRequest());
  
    try {
      const response = await fetchAllBusinesses();
  
      if (response.error) {
        dispatch(fetchBusinessesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchBusinessesSuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(fetchBusinessesFailure(error.message || "Failed to fetch businesses"));
      return { success: false, error: error.message || "Failed to fetch businesses" };
    }
  };
  
// Thunk to update business status
export const updateBusinessStatusAction = (businessId, newStatus, statusReason = null) => async (dispatch) => {
  dispatch(updateBusinessStatusRequest());

  try {
    const response = await updateBusinessStatus(businessId, newStatus, statusReason);

    if (response.success) {
      dispatch(updateBusinessStatusSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(updateBusinessStatusFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to update business status";
    dispatch(updateBusinessStatusFailure(errMsg));
    return { success: false, error: errMsg };
  }
};

  